import { getUserRoles } from "../../api/auth";

/**
 * Гүйлгээний төлөвлөгөө permission levels, mapped onto the existing SFG roles.
 *
 * MANAGE   (ADMIN, MODERATOR) - view, upload, edit and delete.
 * ADD_VIEW (AUTHOR)           - view and upload; may not edit or delete.
 * VIEW     (CUSTOMER)         - read only, and only rows that already have an invoice attached.
 *
 * Creating users is separate and stays ADMIN-only.
 *
 * The backend enforces the same mapping; this module only decides what to render.
 */
export const TRANSACTION_PLAN_VIEW_ROLES = ["ADMIN", "MODERATOR", "AUTHOR", "CUSTOMER"];
export const TRANSACTION_PLAN_ADD_ROLES = ["ADMIN", "MODERATOR", "AUTHOR"];

/** Roles allowed to edit and delete existing rows. Mirrored and enforced on the backend. */
export const TRANSACTION_PLAN_MANAGE_ROLES = ["ADMIN", "MODERATOR"];

/** Roles that only ever see rows with an invoice. Mirrored and enforced on the backend. */
export const TRANSACTION_PLAN_INVOICE_ONLY_ROLES = ["CUSTOMER"];

export const TRANSACTION_PLAN_LEVEL_VIEW = "VIEW";
export const TRANSACTION_PLAN_LEVEL_ADD_VIEW = "ADD_VIEW";
export const TRANSACTION_PLAN_LEVEL_MANAGE = "MANAGE";

export function getTransactionPlanAccess(token = localStorage.getItem("access_token")) {
    const roles = getUserRoles(token);

    const canView = roles.some((role) => TRANSACTION_PLAN_VIEW_ROLES.includes(role));
    const canAdd = roles.some((role) => TRANSACTION_PLAN_ADD_ROLES.includes(role));

    const canManage = roles.some((role) => TRANSACTION_PLAN_MANAGE_ROLES.includes(role));

    const invoiceRowsOnly = roles.some((role) =>
        TRANSACTION_PLAN_INVOICE_ONLY_ROLES.includes(role)
    );

    let permissionLevel = TRANSACTION_PLAN_LEVEL_VIEW;
    if (canManage) permissionLevel = TRANSACTION_PLAN_LEVEL_MANAGE;
    else if (canAdd) permissionLevel = TRANSACTION_PLAN_LEVEL_ADD_VIEW;

    return {
        role: roles[0] || null,
        canView,
        canAdd,
        canUploadInvoice: canAdd,
        canEdit: canManage,
        canDelete: canManage,
        invoiceRowsOnly,
        permissionLevel,
    };
}
